import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const Point = props => (
  <li>
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon icon={['fas', 'circle']} transform="grow-10" />
      <FontAwesomeIcon icon={['fas', 'check']} inverse transform="shrink-3" />
    </span>
    {props.content}
  </li>
);

export default class SellingPoints extends Component {
  constructor(props) {
    super(props);

    this.state = {
      points: [],
    };
  }

  componentDidMount() {
    this.setSellingPoints();
  }

  async setSellingPoints() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo && appInfo.programBenefits && appInfo.programBenefits.length > 0) {
      const points = appInfo.programBenefits.map((point) => {
        console.log(point);
        if (point !== '' && point.length !== 0) {
          // if (/^\d/.test(point)) {
          //   return point.split('.\t')[1];
          // }
          if (!point.startsWith('Program Benefits List for')) {
            return point;
          }
        }

        return null;
      });

      this.setState({
        points,
      });
    }
  }

  render() {
    const { points } = this.state;
    return (
      <ul className="sellingPoints">
        {points && points.length > 0 && points.map((point, i) => {
          const key = i;
          if (point && point !== undefined) {
            return (
              <Point key={key} content={point} />
            );
          }
        })}
      </ul>
    );
  }
}

Point.propTypes = {
  content: PropTypes.string.isRequired,
};
